import React from 'react';
import { useFormContext } from 'react-hook-form';

export default function Title() {
  const { watch } = useFormContext();
  const title = watch('form_name') || 'Add title';
  return (
    <h2 style={{ textAlign: 'center', fontWeight: 'bold' }} className="p-2 mb-0">
      {title}
    </h2>
  );
}
